var meta = { showLeftMenu: false, headIndex: 2 };
export var router = [
	{
		path: '/resourceSimpleSearch',
		meta: meta,
		name: 'resourceSimpleSearch',
		component: resolve => require(["./resourceSimpleSearch.vue"], resolve)
	},
	// {
	// 	path: '/resourceSearch',
	// 	meta: meta,
	// 	name: 'resourceSearch',
	// 	component: resolve => require(["./resourceSearch.vue"], resolve)
	// },
	{
		path: '/bdiSearch',
		meta: meta,
		name: 'bdiSearch',
		component: resolve => require(["./bdiSearch.vue"], resolve),
	},
	// {
	// 	path: '/echoSearch',
	// 	meta: meta,
	// 	name: 'echoSearch',
	// 	component: resolve => require(["./echoSearch.vue"], resolve),
	// },
	{
		path: '/echoSimpleSearch',
		meta: meta,
		name: 'echoSimpleSearch',
		component: resolve => require(["./echoSimpleSearch.vue"], resolve),
	},
	{
		path: '/networkHistorySearch',
		meta: meta,
		name: 'networkHistorySearch',
		component: resolve => require(["./networkHistorySearch.vue"], resolve),	
	},
	{
		path: '/versionSiteSearch',
		meta: meta,
		name: 'versionSiteSearch',
		component: resolve => require(["./versionSiteSearch.vue"], resolve),
	  }
]



// WEBPACK FOOTER //
// ./src/views/queryTools/router.js